import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from 'react-router-dom';
import AuthRouteEvent from '../../utils/authRouteEvent';
import ResaleActivation from '../../pages/resale/resaleActivation/resaleActivation';
import ResaleRateSettings from '../../pages/resale/resaleRateSettings/resaleRateSettings';
import ResaleSettings from '../../pages/resale/resaleSettings/resaleSettings';

export default function ResaleConfigRouter({ organization, event, path }) {
    return (
        <Switch>
            <AuthRouteEvent
                exact
                path={`${path}/activation`}
                allow={['PyvarCapacity.INTERNAL_RESALE', 'PyvarCapacity.INTERNAL_RESALE_ADMIN']}
                render={({ match }) => <ResaleActivation organization={organization} event={event} match={match} />}
            />
            <AuthRouteEvent
                exact
                path={`${path}/settings`}
                allow={['PyvarCapacity.INTERNAL_RESALE', 'PyvarCapacity.INTERNAL_RESALE_ADMIN']}
                render={({ match }) => <ResaleSettings organization={organization} event={event} match={match} />}
            />
            <AuthRouteEvent
                exact
                path={`${path}/:rateId/edit`}
                allow={['PyvarCapacity.INTERNAL_RESALE', 'PyvarCapacity.INTERNAL_RESALE_ADMIN']}
                render={({ match }) => {
                    const rateId = match.params.rateId;
                    return <ResaleRateSettings organization={organization} event={event} rateId={rateId} match={match} />;
                }}
            />
        </Switch>
    );
}

ResaleConfigRouter.propTypes = {
    organization: PropTypes.object.isRequired,
    event: PropTypes.object.isRequired,
    path: PropTypes.string.isRequired
};
